import Button from "@/components/shared/Button/Button";
import AppState from "@/js/AppState";
import clsx from "clsx";
import { useEffect, useMemo, useState } from "react";
import Config from "react-sdk/Config";
import Loader from "react-sdk/components/Loader/Loader";
import classes from './PopupLeaderboard.module.css';
import Texts from "react-sdk/Texts";
import Star from "@/components/shared/Star/Star";


const PlayerRow = ({player, rank, team, isMyRow=false}) => {
  let pseudo = player.Pseudo
  let points = player.CustomData?.stars
  return (
    <>
      <div className={clsx(classes.rank, isMyRow && classes.my_row)}>{rank}</div>
      <div className={clsx(classes.name, isMyRow && classes.my_row)}>
        <div className={classes.teamName}>{team ? team : "?"}</div>
        <div>{pseudo}</div>
      </div>
      <div className={clsx(classes.stars, isMyRow && classes.my_row)}>
        <span>{points ? parseInt(points) : 0}</span>
        <div className={classes.star}><Star /></div>
      </div>
    </>
  )
}

const PagePlayerLeaderboard = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [myRow, setMyRow] = useState(null);
  const [endReached, setEndReached] = useState(false)
  const [nbLoads, setNbLoads] = useState(0);
  const [groupMapping, setGroupMapping] = useState({});
  const pageSize = Config.get("leaderboard_page_size", 100)


  function loadPage() {

    setLoading(true)

    AppState.getGroupList().then(groups => {
      let groupMap = {}
      groups.forEach(group => { groupMap[group.groupId] = group.teamPseudo} )
      setGroupMapping(groupMap)
      let universe = AppState.vertxClient.UserData.getUniverse()
      let collection = universe + "_Users"
      let queryParams = {
        // Filter: "",
        SortFields : { "CustomData.stars" : -1 },
        Projection: ["_id", "Pseudo", "CustomData.stars", "CustomData.group"],
        PageSize: pageSize,
        PageOffset: pageSize * nbLoads,
        FindIndexes: {
          _id: [AppState.vertxClient.UserData.getUserID()]
        }
      }

      if (!AppState.debugMode) {
        let disabledGroups = groups.filter(g => !g.enableRanking).map(g => g.groupId)
        disabledGroups.push("admin")
        disabledGroups.push("superadmin")
        queryParams.Filter = {$and : [{"CustomData.group" : {$exists: true}}, {"CustomData.group" : {$nin: disabledGroups}}]}
      }

      AppState.vertxClient.AdminQuery(collection, queryParams, (success, msg, data) => {
        if(success) {
          setData(list => [...list, ...data.List])
          setMyRow(data.Indexes[0])
          setNbLoads(nb => nb+1)
          if(data.List.length < pageSize) {
            setEndReached(true)
          }
          setLoading(false)

        }
        else {

        }

      })
    })


  }


  useEffect(() => {
    loadPage()

  }, []);

  const myTeamIsInDatas = useMemo(() => {
    if(data && myRow) {
      return data.find(user => user._id === myRow.doc._id)
    }
    return false
  }, [data, myRow ])


  return (
    <div className={classes.PageTeamLeaderboard}>

      <div className={classes.grid}>
        {data.map((player, i) => {
          return <PlayerRow key={player._id} player={player} team={groupMapping[player.CustomData?.group]} rank={i+1} isMyRow={myRow && player._id === myRow.doc._id} />
        })}
        {myRow && !myTeamIsInDatas && <PlayerRow player={myRow.doc} team={groupMapping[myRow.doc.CustomData?.group]} rank={myRow.index + 1} isMyRow={true} />}

        {!loading && !endReached &&
        <div className={classes.load_more_ctnr}>
          <Button  onClick={loadPage}>{Texts.get("popup-leaderboard-load-more-btn", {fallback: "Charger plus..."})}</Button>
        </div>}
      </div>


      {loading &&
      <div className={classes.loading}>
        <Loader />
      </div>}
    </div>
  )
}

export default PagePlayerLeaderboard